import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { IconRedisOutline } from '@icons/IconRedisOutline'
import { SetRedisDialog } from './SetRedisDialog'
import { useFlushRedis, useRefreshExternalTokens } from '@/hooks'

export function RedisMenu() {
  const { mutate: flushRedis } = useFlushRedis()
  const { mutate: refreshExternalTokens } = useRefreshExternalTokens()
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="rounded-full">
          <IconRedisOutline className="size-5" />
          <IconMenuOutline className="size-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {/* <DropdownMenuLabel>My Account</DropdownMenuLabel> */}
        <DropdownMenuGroup>
          <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
            <SetRedisDialog />
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={(_e) => flushRedis()}>
            <span>Flush Redis</span>
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={(_e) => refreshExternalTokens()}>
            <span>Regenerate External Tokens</span>
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
